var _module = require('../components/module');

/*
capitalize
converts the first character of a string to uppercase
and the remaining characters to lowercase
*/

_module.filter('capitalize', [
    function capitalize() {
        return function(str) {
            return (!!str) ? str.charAt(0).toUpperCase() + str.substr(1).toLowerCase() : '';
        };
    }
]);
